import React from 'react'
import twoBg from '../../assets/images/background/image-5.jpg';
import threebg from '../../assets/images/background/image-6.jpg';
import { Link } from 'react-router-dom'
import bgfive from '../../assets/images/background/image-5.jpg'
import bg12 from '../../assets/images/background/bg-12.png'
import bg13 from '../../assets/images/background/bg-13.png'

function Winningchef() {
    return (
        <>
            <section className="fluid-section">
                <div className="outer-container">
                    <div className="row clearfix">
                        <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="inner wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="image-layer" style={{ backgroundImage: `url(${twoBg})` }}></div>

                                <div className="image"><img src={bgfive} alt="" /></div>
                            </div>
                        </div>

                    <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <div className="right-bg"><img src={bg12} alt="" title="" /></div>
                            <div className="inner clearfix wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="content-box">
                                    <div className="title-box centered">
                                        <div className="subtitle"><span>15 godina iskustva</span></div>
                                        <div className="pattern-image">
                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                                        </div>
                                        <h2>Strast Prema Kvalitetu</h2>
                                        <div className="text">Svaki dan donosimo vam autentične ukuse i sveže pripremljena jela. Naša misija je da kroz kvalitetnu hranu i odličnu uslugu postanemo vaš prvi izbor u gradu. Pridružite nam se i uverite se sami!</div>
                                    </div>
                                    <div className="info">
                                        <div className="signature" style={{ fontFamily: "'Great Vibes', cursive", fontSize: "48px", color: "var(--main-color)", marginBottom: "20px" }}>BonAppetit</div>
                                        <div className="author">Bon Appetit - Vaša Picerija</div>
                                    </div>
                                    <div className="link-box">
                                        <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                            <span className="btn-wrap">
                                                <span className="text-one">pogledajte meni</span>
                                                <span className="text-two">pogledajte meni</span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="fluid-section alternate">
                <div className="outer-container">
                    <div className="row clearfix">

                        <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="inner wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="image-layer" style={{ backgroundImage: `url(${threebg})` }}></div>
                                <div className="image"><img src={threebg} alt="" /></div>
                            </div>
                        </div>

                        <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="left-bg"><img src={bg13} alt="" title="" /></div>
                            <div className="inner clearfix wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="content-box">
                                    <div className="title-box centered">
                                        <div className="subtitle"><span>Nezaboravan Ukus</span></div>

                                        <div className="pattern-image">
                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                                        </div>

                                        <h2>Porodični Ručak ili Zabava?</h2>
                                        <div className="text">Bilo da organizujete rođendan, poslovni sastanak ili samo želite ukusnu večeru u lokalu ili kod kuće, mi smo tu za vas. Naša raznovrsna ponuda i mogućnost porudžbina za grupe čine nas savršenim izborom za svaku priliku.</div>
                                    </div>
                                    <div className="link-box">
                                        <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                            <span className="btn-wrap">
                                                <span className="text-one">Pogledajte Ponudu</span>
                                                <span className="text-two">Pogledajte Ponudu</span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Winningchef